import {EntityModel} from "@fedeltapointofsale/data-client";
import {MeasureData} from "./measure.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class MeasureEntityModel extends EntityModel<MeasureData> {

    constructor(injector: Injector) {
        super(injector, MeasureData);
    }
}
